import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { resetPageScroll } from "../../js/utils/scrollToFooter";

export default function ScrollReset() {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (typeof window.history?.scrollRestoration === "string") {
      window.history.scrollRestoration = "manual";
    }
    if (hash) {
      window.scrollTo(0, 0);
      return undefined;
    }
    resetPageScroll();
    const frame = requestAnimationFrame(() => {
      resetPageScroll();
      requestAnimationFrame(resetPageScroll);
    });
    const timer = window.setTimeout(resetPageScroll, 80);
    return () => {
      cancelAnimationFrame(frame);
      window.clearTimeout(timer);
    };
  }, [pathname, hash]);

  return null;
}
